import { createNewProject, updateProject, useAppDispatch } from '@core/core/store'
import type { StoppableEvent } from '@library/utils'
import { useCallback } from 'react'

import type { ProjectToUpdateInfo } from '../types'

export const useProjectInfoApply = (
  info: ProjectToUpdateInfo,
  close?: (event: StoppableEvent) => void,
) => {
  const dispatch = useAppDispatch()

  return useCallback<NonNullable<typeof close>>(
    event => {
      const { name, type, year, fieldId, companyId, id } = info
      if (!name || !type) return

      if (id) {
        dispatch(updateProject(id, name, type, year, companyId, fieldId))
      } else {
        dispatch(createNewProject(name, type, year, companyId, fieldId))
      }

      close?.(event)
    },
    [info],
  )
}
